<div class="flex justify-center items-center h-full w-full">
  <mat-spinner diameter="30" class="text-blue-600 dark:text-blue-400"></mat-spinner>
</div>
